import { __rest } from "tslib";
import React from "react";
import classnames from "classnames";
import flatten from "Shared/flatten-appearance";
import * as styles from "../../../styles/objects/buttons.scss";
import Icon from "Shared/Icon";
function isLink(props) {
    return "href" in props;
}
function classnamesFromApperance(appearance) {
    let apperances = flatten(appearance);
    if (apperances.includes("link") && !apperances.includes("bare")) {
        apperances.push("bare");
    }
    return apperances.map((name) => styles[name]);
}
export default function Button(props) {
    const computedProps = Object.assign({}, props, {
        className: classnames(props.className, classnamesFromApperance(props.appearance), { [styles.disabled]: props.disabled }),
    });
    const { appearance } = computedProps, restProps = __rest(computedProps, ["appearance"]);
    return isLink(restProps) ? (React.createElement(AnchorVariant, Object.assign({}, restProps))) : (React.createElement(ButtonVariant, Object.assign({}, restProps, { appearance: appearance })));
}
function ButtonVariant(computedProps) {
    return (React.createElement("button", Object.assign({}, computedProps, { type: computedProps.type || "button", disabled: computedProps.disabled }),
        !!computedProps.appearance && computedProps.appearance === "add" && (React.createElement(Icon, { name: "plus" })),
        computedProps.children));
}
function AnchorVariant(props) {
    const { disabled, type } = props, anchorProps = __rest(props, ["disabled", "type"]);
    return (React.createElement("a", Object.assign({}, anchorProps, { className: classnames(styles.base, anchorProps.className, {
            [styles.disabled]: disabled,
        }) }), anchorProps.children));
}
